import { FunctionComponent, useCallback } from "react";
import { IIconProps } from "../../../../assets/icons/icon";
import { useTranslation } from "react-i18next";

export const GeneVariationExplanationHero: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  const translator = useTranslation().t;
  const t = useCallback((key: string) => translator(`gene_variations.page_2.hero.${key}`), [translator]);

  return (
    <svg viewBox="0 0 717 217" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <rect id="path-3" x="2" y="2" width="328" height="98" rx="16" />
      </defs>
      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="12b-Generklärung" transform="translate(-586.000000, -504.000000)">
          <g id="Card" transform="translate(521.000000, 160.000000)">
            <g id="Explanation" transform="translate(65.926993, 344.000000)">
              <g id="UI-Elements/Card/Nährstoffe-Copy-3" transform="translate(195.073007, 34.000000)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-3" />
                </mask>
                <rect stroke="#ECECEC" strokeWidth="2" x="1" y="1" width="330" height="100" rx="16" />
                <g id="Funktion" mask="url(#mask-2)">
                  <g transform="translate(19.000000, 18.000000)">
                    <g id="3" transform="translate(31.000000, 43.000000)">
                      <text
                        id="T/G"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="16"
                        fontWeight="300"
                        line-spacing="24"
                        fill="#222222"
                      >
                        <tspan x="86" y="18">
                          A/A
                        </tspan>
                      </text>
                      <text
                        id="Genotyp"
                        fontFamily="Navigo-Bold, Navigo"
                        fontSize="14"
                        fontWeight="bold"
                        fill="#222222"
                      >
                        <tspan x="0" y="19">
                          {t("genotype")}
                        </tspan>
                      </text>
                    </g>
                    <g id="2" transform="translate(31.000000, 21.000000)">
                      <text
                        id="rs8055236"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="16"
                        fontWeight="300"
                        line-spacing="24"
                        fill="#222222"
                      >
                        <tspan x="86" y="18">
                          rs662799
                        </tspan>
                      </text>
                      <text
                        id="rsNCBI-Copy"
                        fontFamily="Navigo-Bold, Navigo"
                        fontSize="14"
                        fontWeight="bold"
                        fill="#222222"
                      >
                        <tspan x="0" y="20">
                          rsNCBI
                        </tspan>
                      </text>
                    </g>
                    <g id="HL">
                      <text id="CHD13" fontFamily="Navigo-Bold, Navigo" fontSize="18" fontWeight="bold" fill="#222222">
                        <tspan x="31" y="21">
                          APOA5
                        </tspan>
                      </text>
                      <g id="Icons/Level/Gene/1" transform="translate(0.000000, 4.000000)">
                        <circle id="Oval" fill="#3A6D79" cx="8" cy="8" r="8" />
                        <g
                          id="Group"
                          transform="translate(7.903728, 8.000000) rotate(90.000000) translate(-7.903728, -8.000000) translate(4.903728, 4.403728)"
                          stroke="#FFFFFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.75"
                        >
                          <path
                            d="M2.9988,1.19254305 C3.002,1.24590512 3.002,1.36336214 2.9988,1.54491411 L3.00093333,7.19254305"
                            id="Path"
                          />
                          <polyline id="Path" points="0 3 3 0 6 3" />
                        </g>
                      </g>
                      <g id="Icons/Level/Gene/1-Copy" transform="translate(0.000000, 25.000000)">
                        <circle id="Oval" fill="#3A6D79" opacity="0.3" cx="8" cy="8" r="8" />
                        <g
                          id="Group"
                          transform="translate(7.903728, 8.000000) scale(-1, 1) rotate(90.000000) translate(-7.903728, -8.000000) translate(4.903728, 4.403728)"
                          stroke="#FFFFFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.75"
                        >
                          <path
                            d="M2.9988,1.19254305 C3.002,1.24590512 3.002,1.36336214 2.9988,1.54491411 L3.00093333,7.19254305"
                            id="Path"
                          />
                          <polyline id="Path" points="0 3 3 0 6 3" />
                        </g>
                      </g>
                    </g>
                    <g id="People" transform="translate(233.000000, 3.821107)">
                      <circle id="Oval" stroke="#ECECEC" strokeWidth="3" cx="29" cy="29.1788934" r="29" />
                      <path
                        d="M15.5631865,3.47295223 C6.31212349,8.31853456 0,18.0115763 0,29.1788934 C0,45.1951511 12.9837423,58.1788934 29,58.1788934 C45.0162577,58.1788934 58,45.1951511 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                        id="94"
                      />
                      <path
                        d="M1.27752326,20.6400689 C0.447032725,23.3395504 0,26.2070168 0,29.1788934 C0,45.1951511 12.9837423,58.1788934 29,58.1788934 C45.0162577,58.1788934 58,45.1951511 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                        id="76"
                        stroke="#3A6D79"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.2285157,52.0972917 C16.1373803,55.9092616 22.3036397,58.1788934 29,58.1788934 C45.0162577,58.1788934 58,45.1951511 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                        id="58"
                      />
                      <path
                        d="M37.966449,56.7661547 C49.5942401,52.9894905 58,42.0658272 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                        id="47"
                        stroke="#3A6D79"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M48.7624921,7.95507316 C43.5834455,3.13048781 36.6364137,0.178893398 29,0.178893398"
                        id="13"
                      />
                      <path
                        d="M35.0978973,0.821106602 C33.1317682,0.400353699 31.0917465,0.178893398 29,0.178893398"
                        id="2"
                        stroke="#3A6D79"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <text
                        id="2%"
                        fontFamily="Navigo-Bold, Navigo"
                        fontSize="13.5333333"
                        fontWeight="bold"
                        fill="#222222"
                      >
                        <tspan x="14.5389" y="34.1788934">
                          76%
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g id="Group" mask="url(#mask-2)">
                  <g transform="translate(293.000000, 13.000000)">
                    <circle id="Oval" fillOpacity="0.8" fill="#FFFFFF" cx="12" cy="12" r="14" />
                    <circle
                      id="Oval"
                      stroke="#222222"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      cx="12"
                      cy="12"
                      r="8"
                    />
                    <g id="?" transform="translate(9.100000, 7.700000)" fill="#222222" fillRule="nonzero">
                      <path
                        d="M2.62507213,6.02929688 C3.076244,6.02929688 3.35163463,5.8125 3.48640025,5.40234375 C3.60358775,4.98046875 3.7559315,4.76953125 4.55866588,4.30664062 C5.419994,3.80859375 5.82429088,3.2109375 5.82429088,2.34960938 C5.82429088,0.92578125 4.65827525,0 2.88288463,0 C1.5528065,0 0.574290879,0.50390625 0.181712754,1.2421875 C0.0586658789,1.46484375 7.21288574e-05,1.69335938 7.21288574e-05,1.9453125 C-0.00578724614,2.47265625 0.345775254,2.8125 0.896556504,2.8125 C1.30671275,2.8125 1.64069713,2.61914062 1.810619,2.23828125 C1.99225963,1.81054687 2.30866588,1.59375 2.77741588,1.59375 C3.30475963,1.59375 3.685619,1.92773438 3.685619,2.40234375 C3.685619,2.90625 3.48054088,3.15820312 2.68366588,3.62695312 C2.044994,3.99023438 1.69929088,4.41796875 1.69929088,5.05664062 L1.69929088,5.09179688 C1.69929088,5.6484375 2.06257213,6.02929688 2.62507213,6.02929688 Z M2.654369,8.72460938 C3.263744,8.72460938 3.76179088,8.26171875 3.76179088,7.66992188 C3.76179088,7.08398438 3.263744,6.62109375 2.654369,6.62109375 C2.03913463,6.62109375 1.54694713,7.08398438 1.54694713,7.66992188 C1.54694713,8.26171875 2.03913463,8.72460938 2.654369,8.72460938 Z"
                        id="Shape"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <text
                id="Dieser-Anteil-der-We"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                fill="#222222"
              >
                <tspan x="553" y="88">
                  {t("right_middle.line_1")}{" "}
                </tspan>
                <tspan x="553" y="107">
                  {t("right_middle.line_2")}{" "}
                </tspan>
                <tspan x="553" y="126">
                  {t("right_middle.line_3")}{" "}
                </tspan>
                <tspan x="553" y="145">
                  {t("right_middle.line_4")}
                </tspan>
              </text>
              <g id="Group" transform="translate(0.000000, 97.000000)">
                <text
                  id="Vorwärtsstrang-Umgek"
                  fontFamily="Navigo-Light, Navigo"
                  fontSize="14"
                  fontWeight="300"
                  fill="#222222"
                >
                  <tspan x="20" y="15">
                    {t("left_middle.line_1")}
                  </tspan>
                  <tspan x="20" y="34">
                    {t("left_middle.line_2")}
                  </tspan>
                </text>
                <g transform="translate(0.000000, 3.000000)" id="Icons/Level/Blut/4">
                  <circle id="Oval" fill="#3A6D79" cx="7" cy="7" r="7" />
                  <g
                    id="Group"
                    transform="translate(6.915762, 7.000000) rotate(90.000000) translate(-6.915762, -7.000000) translate(4.290762, 3.853262)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.3125"
                  >
                    <path
                      d="M2.62395,1.04347517 C2.62675,1.09016698 2.62675,1.19294187 2.62395,1.35179984 L2.62581667,6.29347517"
                      id="Path"
                    />
                    <polyline id="Path" points="0 2.625 2.625 2.51282215e-14 5.25 2.625" />
                  </g>
                </g>
                <g transform="translate(0.000000, 23.000000)" id="Icons/Level/Blut/4-Copy">
                  <circle id="Oval" fill="#3A6D79" cx="7" cy="7" r="7" />
                  <g
                    id="Group"
                    transform="translate(6.915762, 7.000000) scale(-1, 1) rotate(90.000000) translate(-6.915762, -7.000000) translate(4.290762, 3.853262)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.3125"
                  >
                    <path
                      d="M2.62395,1.04347517 C2.62675,1.09016698 2.62675,1.19294187 2.62395,1.35179984 L2.62581667,6.29347517"
                      id="Path"
                    />
                    <polyline id="Path" points="0 2.625 2.625 3.1343304e-14 5.25 2.625" />
                  </g>
                </g>
              </g>
              <text
                id="Hier-kannst-du-mehr"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                fill="#222222"
              >
                <tspan x="553" y="21">
                  {t("right_top.line_1")}
                </tspan>
                <tspan x="553" y="40">
                  {t("right_top.line_2")}
                </tspan>
              </text>
              <text
                id="Die-Symbole-zeigen-d"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                fill="#222222"
              >
                <tspan x="0" y="40">
                  {t("left_top.line_1")}{" "}
                </tspan>
                <tspan x="0" y="59">
                  {t("left_top.line_2")}{" "}
                </tspan>
                <tspan x="0" y="78">
                  {t("left_top.line_3")}
                </tspan>
              </text>
              <text
                id="Der-Genotyp-beschrei"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                fill="#222222"
              >
                <tspan x="150" y="176">
                  {t("bottom_left.line_1")}{" "}
                </tspan>
                <tspan x="150" y="195">
                  {t("bottom_left.line_2")}{" "}
                </tspan>
                <tspan x="150" y="214">
                  {t("bottom_left.line_3")}
                </tspan>
              </text>
              <text
                id="Dieser-Wert-klassifi"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                fill="#222222"
              >
                <tspan x="382" y="176">
                  {t("bottom_right.line_1")}{" "}
                </tspan>
                <tspan x="382" y="195">
                  {t("bottom_right.line_2")}{" "}
                </tspan>
                <tspan x="382" y="214">
                  {t("bottom_right.line_3")}
                </tspan>
              </text>
              <text
                id="Um-dieses-Gen-geht’s"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                fill="#222222"
              >
                <tspan x="297" y="16">
                  {t("top_middle")}
                </tspan>
              </text>
              <path
                d="M207.320414,66.9036556 C206.373414,66.7036556 205.723414,68.0116556 206.638414,68.5236556 C208.049414,69.3126556 209.460414,69.9996556 210.902414,70.6076556 C198.396857,71.0103413 190.292922,74.3019448 181.865392,79.9880703 C180.741989,80.7460401 181.584727,81.8350503 182.587061,81.1859831 C193.000655,74.4426005 200.435335,71.9968896 214.298414,72.3226556 C212.846414,72.9636556 211.394414,73.6046556 209.942414,74.2456556 C208.888414,74.7096556 209.800414,76.2556556 210.847414,75.7936556 C213.568414,74.5926556 216.289414,73.3916556 219.010414,72.1906556 C219.594414,71.9326556 219.601414,70.8976556 219.010414,70.6426556 C215.216414,69.0016556 211.369414,67.7586556 207.320414,66.9036556 Z"
                id="Fill-1-Copy-2"
                fill="#000000"
                transform="translate(200.390702, 74.133602) scale(-1, -1) rotate(20.000000) translate(-200.390702, -74.133602) "
              />
              <path
                d="M282.752826,14.9054103 C281.804826,14.5764103 281.226826,16.0224103 282.077826,16.5074103 C283.750826,17.4614103 285.443826,18.3614103 287.157826,19.2204103 C277.943826,18.7254103 266.291826,20.4004103 259.467826,26.5814103 C259.288521,26.8226913 258.977188,27.125358 258.533826,27.4894103 C257.147826,28.9334103 250.035234,37.6910925 249.055167,39.5823471 C248.654372,40.3557701 249.8685,40.4334596 250.809515,39.1079904 C254.863379,33.3979109 259.851156,28.7811222 261.512826,27.4544103 C261.665826,27.3354103 261.816826,27.2094103 261.969826,27.1004103 C270.342826,21.1274103 281.868826,19.8234103 291.776826,21.3964103 C291.873826,21.4114103 291.968826,21.4034103 292.060826,21.3874103 C292.241826,21.5034103 292.422826,21.6204103 292.602826,21.7394103 C290.935826,22.8834103 289.221826,23.6824103 287.225826,24.2504103 C286.126826,24.5634103 286.593826,26.2814103 287.698826,25.9654103 C290.416826,25.1894103 292.572826,24.0634103 294.796826,22.3294103 C295.283826,21.9504103 295.030826,21.2254103 294.617826,20.9374103 C290.915826,18.3624103 287.004826,16.3844103 282.752826,14.9054103 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(272.019930, 27.498291) rotate(-27.000000) translate(-272.019930, -27.498291) "
              />
              <path
                d="M250.621529,146.970122 C248.585805,137.096779 247.774316,127.101633 247.768046,117.05604 C247.766758,114.991991 246.826419,114.964137 246.752399,117.013351 C246.428699,125.974775 247.082589,134.888489 248.403529,143.763122 C247.680529,142.484122 246.958529,141.204122 246.232529,139.927122 C245.743529,139.067122 244.325529,139.639122 244.619529,140.607122 C245.689529,144.115122 247.174529,147.122122 249.352529,150.096122 C249.726529,150.607122 250.521529,150.719122 250.872529,150.096122 C252.265529,147.627122 253.667529,145.163122 255.040529,142.683122 C255.579529,141.709122 254.102529,140.843122 253.546529,141.810122 C252.560529,143.523122 251.592529,145.248122 250.621529,146.970122 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(249.868355, 133.007256) rotate(50.000000) translate(-249.868355, -133.007256) "
              />
              <path
                d="M521.360762,86.6257209 C518.213667,91.5394174 508.294588,107.371469 502.736588,116.068469 C502.043588,113.117469 501.346588,110.166469 500.646588,107.216469 C500.420588,106.262469 498.792588,106.440469 498.899588,107.452469 C499.396588,112.148469 499.892588,116.843469 500.389588,121.538469 C500.471588,122.319469 501.294588,122.694469 501.907588,122.167469 C505.898588,118.739469 509.898588,115.319469 513.877588,111.876469 C514.739588,111.130469 513.488588,109.895469 512.629588,110.628469 C509.070588,113.663469 505.527588,116.718469 501.980588,119.767469 C501.954588,119.520469 501.928588,119.273469 501.902588,119.026469 C502.292588,119.244469 502.852588,119.148469 503.117588,118.729469 C509.685588,108.309469 516.248588,97.8874689 522.806588,87.4604689 C525.911588,82.5224689 524.507857,81.7120244 521.360762,86.6257209 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(511.720351, 102.867807) rotate(-115.000000) translate(-511.720351, -102.867807) "
              />
              <path
                d="M542.296307,38.6846469 C542.200307,38.5446469 542.055307,38.4446469 541.859307,38.4096469 C539.739307,37.0766469 537.619307,35.7436469 535.499307,34.4096469 C534.519307,33.7936469 533.618307,35.3456469 534.594307,35.9576469 C535.961307,36.8166469 537.328307,37.6756469 538.695307,38.5336469 C529.571307,38.7936469 518.802642,37.5909419 511.13459,33.5966866 C504.942891,30.3714572 503.632201,27.9408609 500.997369,21.720434 C500.563809,20.6968673 499.656951,20.665036 500.089659,22.2695033 C501.350102,26.9431805 503.233883,30.9227966 507.494789,33.5966866 C516.864642,39.4766469 527.383307,40.4626469 538.704307,40.2206469 C536.782307,41.4866469 534.810307,42.6526469 532.737307,43.7106469 C531.826307,44.1766469 532.469307,45.5636469 533.418307,45.3256469 C537.077307,44.4106469 540.354307,43.0216469 543.556307,41.0206469 C544.135307,40.6586469 544.132307,39.8386469 543.556307,39.4766469 C543.136307,39.2126469 542.716307,38.9486469 542.296307,38.6846469 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(521.982500, 33.176361) scale(1, -1) translate(-521.982500, -33.176361) "
              />
              <path
                d="M421.153536,137.606985 C421.048841,137.451768 420.890709,137.340899 420.676959,137.302095 C418.36496,135.82421 416.052961,134.346326 413.740962,132.867333 C412.672208,132.184379 411.689609,133.905067 412.754001,134.583586 C414.244804,135.535951 415.735607,136.488316 417.22641,137.439572 C407.276091,137.727832 395.532157,136.394404 387.169644,131.966011 C380.417192,128.39023 378.987799,125.695451 376.114342,118.798922 C375.641517,117.664104 374.652528,117.628813 375.124425,119.40767 C376.49902,124.589332 378.553406,129.001495 383.200203,131.966011 C393.418642,138.485068 404.889933,139.578236 417.236225,139.309933 C415.140158,140.713536 412.989563,142.006269 410.728821,143.179263 C409.735316,143.695913 410.436549,145.233667 411.471496,144.969798 C415.461875,143.955347 419.035658,142.415376 422.527648,140.196886 C423.159085,139.79554 423.155814,138.886414 422.527648,138.485068 C422.069611,138.192373 421.611573,137.899679 421.153536,137.606985 Z"
                id="Fill-1-Copy"
                fill="#000000"
                transform="translate(399.000000, 131.500000) rotate(30.000000) translate(-399.000000, -131.500000) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
